import { useState } from "react";

export function useComponentSelection() {
	const [selectedComponentId, setSelectedComponentId] = useState<
		string | null
	>(null);

	const handleComponentClick = (id: string) => {
		setSelectedComponentId(id);
	};

	const clearSelection = () => {
		setSelectedComponentId(null);
	};

	return {
		selectedComponentId,
		setSelectedComponentId,
		handleComponentClick,
		clearSelection,
	};
}
